import { createTheme } from "@mui/material"
import { blue, red } from "@mui/material/colors"

export const DarkTheme = createTheme({
    palette: {
        primary: {
            main: blue[700],
            light: red[500],
            dark: red[900],
            contrastText: '#FFFFFF'
        },
        one_primary: {
            main: '#8A05BE',
            light: '#A137CB',
            dark: '#600385',
            contrastText: '#FFFFFF'
        }
    }
})
